@if (this.insuranceCompany$ | async; as insuranceCompany) {
  <div
    class="tab-pane fade flex-even active show"
    id="productLines"
    role="tabpanel"
    aria-labelledby="produc-lines-tab"
    >
    <div class="d-flex flex-column h-100">
      <div class="row mt-2">
        <table class="table table-striped border-bottom">
          <thead>
            <tr>
              <th>
                <a translate>INSURANCECOMPANY_LBL_PRODUCT_LINES_NAME</a>
              </th>
              <th>
                <a translate>INSURANCECOMPANY_LBL_PRODUCT_LINES_CATEGORY</a>
              </th>
              <th>
                <a translate>INSURANCECOMPANY_LBL_PRODUCT_LINES_PRODUCT_COUNT</a>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (productLine of insuranceCompany.productLines; track productLine.id) {
              <tr [routerLink]="'/Insurance/ProductLines/Details/' + productLine.id"
                class="row-action">
                <td>{{ productLine.name }}</td>
                <td>{{ productLine.productCategoryName }}</td>
                <td>{{ productLine.productsCount }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
}
